import { META_TAGS } from 'b2b-apps/shop/common/utils/seo/metaTags';
import { HeadDataType, MetaTagsType, MetaTagType } from 'b2b-apps/shop/content/components/ModularPage';

const prepareHeadData = (
  socialMeta: Record<string, any> | undefined,
  defaultPageDescription: MetaTagType,
): HeadDataType => {
  if (!socialMeta) {
    return {
      metaTags: [],
      title: '',
    };
  }

  const { title, _metadata, ...socialMetadata } = socialMeta;
  const keys = Object.keys(socialMetadata);

  const metaTags = keys.reduce((acc, curr) => {
    const val = socialMetadata[curr];
    const key = curr.replace(/_/g, ':');

    if (key === META_TAGS.description) {
      acc[0] = {
        name: 'description',
        content: val,
      };
      return acc;
    }

    if (key === META_TAGS.metaDescription) {
      acc[0] = {
        name: 'description',
        content: val,
      };
      return acc;
    }

    acc.push({
      name: key,
      content: key === META_TAGS.ogImage ? val.url : val,
      property: key,
    });
    return acc;
  }, [
    defaultPageDescription,
  ] as MetaTagsType);

  return {
    title: title || '',
    metaTags,
  };
};

export {
  prepareHeadData,
};
